<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>页面不存在</span>
        </div>
        <div class="text-center">
          <i class="el-icon-warning-outline" style="font-size: 60px; color: #f56c6c; margin-bottom: 20px;"></i>
          <h2>404 - 页面不存在</h2>
          <p class="text-muted">您访问的页面不存在或已被删除</p>
          <p class="current-path">当前访问路径: {{ $route.fullPath }}</p>
          <div class="mt-4">
            <el-button type="primary" @click="goBack">返回上一页</el-button>
            <el-button @click="goHome">返回首页</el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background-color: #f5f7fa;
}

.not-found-content {
  width: 100%;
  max-width: 500px;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #889099;
  margin-bottom: 10px;
}

.current-path {
  color: #1890ff;
  margin-bottom: 20px;
  word-break: break-all;
}

.mt-4 {
  margin-top: 20px;
}
</style>